<script>
import DspSearch from '../../common/components/DspSearch.vue'
import Newsfeed from '../../common/components/Newsfeed.vue'
import { onMounted } from 'vue'

export default {
  components: {
    DspSearch,
    Newsfeed
  },
  setup() {
    onMounted(() => {
    // Fix addtoany rendering issue - #207
    if (window.a2a) {
      window.a2a.init_all()
    }

    // Add parameter to form link URL
    const formLink = document.querySelector('a[href="/formulaire-rh"]')
    const articleDataset = document.querySelector('article').dataset
    if (formLink && 'historyNodeId' in articleDataset) {
      formLink.href = `/formulaire-rh?poste=${articleDataset.historyNodeId}`
    }
  })
  },
}
</script>

<style lang="sass">
@import ../../common/styles/settings
@import ../../common/styles/mixins
@import PageArticle
</style>
